import { Response } from '@models/Response';

import * as api from './api';

export function getBudget(orderId: string): Promise<Response<any>> {
  return api.get(`shopping-bag/budget/${orderId}`).catch((error) => {
    return Promise.resolve(error.response);
  });
}
